import React from 'react';

import TimesIcon from 'assets/img/times.svg';
import DownloadIcon from 'assets/img/download.svg';

import Spacer from 'components/spacer';
import Hr from 'components/hr';

import formatSize from 'helpers/format-size';

import './index.css';


const getRealFile = (file, listing) => {
    if (file) {
        return file.file;
    } else if(listing) {
        return {
            name: listing.object_name,
            size: listing.object_size,
            download_token: listing.download_token,
            transfer_id: listing.transfer_id
        }
    }
}

const FileRow = ({ file, listing, onRemoveFile, onDownload }) => {
  const realFile = getRealFile(file, listing);

  return (
    <>
      <Spacer size='xs'/>
      <div className='files-row'>
        <div className='files-row__info'>
          <p>{realFile.name}</p>
          <Spacer size='xxs' />
          <span>{formatSize(realFile.size, true)}</span>
        </div>
        {onRemoveFile &&
          <img
              alt='cancel icon'
              className='clickable icon'
              src={TimesIcon}
              onClick={() => {
                  onRemoveFile(file);
              }}
          />
        }
        {onDownload &&
          <div className='files-row__icon-container'>
            <img
              alt='download icon'
              className='clickable icon'
              src={DownloadIcon}
              onClick={() => {
                  onDownload(realFile);
              }}
            />
          </div>
        }
      </div>
      <Spacer size='xs'/>
      <Hr />
    </>
  );
}

export default FileRow;